var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, CustomElement, html, nothing, Prop, State } from '@sick-davinci/ce-decorators';
import { NavigationMenu } from './navigation-menu/NavigationMenu';
import { NavigationMenuItem } from './navigation-menu/navigation-menu-item/NavigationMenuItem';
import { style } from './Navigation.style';
/**
 * A `davinci-core-navigation` generates a DaVinci navigation
 *
 * @example
 * ```html
 * <davinci-core-navigation type="tree">
 *   <davinci-core-navigation-item route="/">home</davinci-core-navigation-item>
 *   <davinci-core-navigation-item route="/products" active>products</davinci-core-navigation-item>
 *   <davinci-core-navigation-item route="/settings/app" disabled>settings</davinci-core-navigation-item>
 *   <davinci-core-navigation-item route="/settings/user">user-settings</davinci-core-navigation-item>
 * </davinci-core-navigation>
 * ```
 */

export let Navigation = (_dec = Component({
  style: [style],
  tag: 'davinci-core-navigation',
  dependencies: [NavigationMenu, NavigationMenuItem]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = State(), _dec5 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class Navigation extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "moreMenuItems", _descriptor2, this);

    this.allItems = [];
    this.navigationWidth = 0;
    this.menuButtonWidth = 60;
  }

  componentFirstRender() {
    this.navigationEl = this.shadowRoot.querySelector('.navigation');
    this.navigationObserver = new ResizeObserver(entries => {
      this.navigationWidth = entries[0].contentRect.width;
      this.recalculateMoreMenu(this.navigationWidth);
    });
    this.navigationObserver.observe(this.navigationEl);
  }

  componentDisconnected() {
    if (this.navigationObserver) {
      this.navigationObserver.disconnect();
    }
  }

  recalculateMoreMenu(navigationWidth = -1) {
    if (!this.allItems || this.allItems.length === 0) {
      return;
    }

    if (navigationWidth === -1) {
      navigationWidth = this.shadowRoot.querySelector('.items').getBoundingClientRect().width;
    }

    const {
      widestItemInfo,
      allItemsWidth
    } = this.getItemsWidthInfos(this.allItems);
    const {
      menuItems,
      firstMenuItemIndex,
      remainingItemsWidth
    } = this.getMenuData(this.allItems, navigationWidth, allItemsWidth);
    this.moreMenuItems = menuItems;
    this.updateHiddenAttribute(this.allItems, firstMenuItemIndex);
    this.avoidMenuPositionShifts(this.navigationEl, widestItemInfo, this.allItems.length, this.moreMenuItems.length, remainingItemsWidth);
    requestAnimationFrame(() => {
      // Defer rerender into next cycle as we may already have rendered in this one.
      this.scheduleRender(true);
    });
  }

  getMenuData(items, navigationWidth, allItemsWidth) {
    const menuItems = [];
    let firstMenuItemIndex = -1;
    let menuItemsWidth = 0;

    if (allItemsWidth > navigationWidth) {
      [...items].reverse().forEach((item, index) => {
        const testWidth = allItemsWidth + (menuItems.length ? this.menuButtonWidth : 0) - menuItemsWidth;

        if (testWidth > navigationWidth) {
          firstMenuItemIndex = items.length - 1 - index;
          menuItems.unshift(items[firstMenuItemIndex]);
          menuItemsWidth += item.getWidthInfo().overall;
        }
      });
    }

    const remainingItemsWidth = allItemsWidth + (menuItems.length ? this.menuButtonWidth : 0) - menuItemsWidth;
    return {
      menuItems,
      firstMenuItemIndex,
      remainingItemsWidth
    };
  }

  updateHiddenAttribute(items, firstMenuItemIndex) {
    items.forEach((item, index) => {
      item.hidden = firstMenuItemIndex > -1 && index >= firstMenuItemIndex;
    });
  }

  getItemsWidthInfos(items) {
    let widestItemInfo = {
      content: 0,
      overall: 0,
      spacingLeft: 0,
      spacingRight: 0
    };
    let allItemsWidth = 0;
    items.forEach(item => {
      const itemDimensions = item.getWidthInfo();

      if (itemDimensions.content > widestItemInfo.content) {
        widestItemInfo = itemDimensions;
      }

      allItemsWidth += itemDimensions.overall;
    });
    return {
      widestItemInfo,
      allItemsWidth
    };
  }

  avoidMenuPositionShifts(navigationEl, widesItemInfo, allItemsCount, menuItemsCount, remainingItemsWidth) {
    const menuEl = this.shadowRoot.querySelector('davinci-navigation-menu');
    const minWidth = widesItemInfo.overall;
    const onlyMenu = allItemsCount === menuItemsCount; // reset

    navigationEl.classList.remove('minimal');
    menuEl && menuEl.classList.remove('right');
    navigationEl.style.minWidth = minWidth + 'px';

    if (onlyMenu) {
      navigationEl.classList.add('minimal');
      menuEl && menuEl.classList.add('right');
    } else if (remainingItemsWidth <= minWidth) {
      menuEl && menuEl.classList.add('right');
    }
  }

  render() {
    return html`
      <div class="navigation">
        <div class="items" @item-rendered="${() => this.recalculateMoreMenu()}">
          <slot @slotchange="${this.onSlotChanged}"></slot>
          ${this.renderMoreMenu()}
        </div>
        <div class="bottom-line"></div>
      </div>
    `;
  }

  renderMoreMenu() {
    if (this.moreMenuItems.length) {
      return html`
        <davinci-navigation-menu>
          ${this.renderMenuItems()}
        </davinci-navigation-menu>
      `;
    } else {
      return nothing;
    }
  }

  renderMenuItems() {
    return this.moreMenuItems.map(item => {
      return html`<davinci-navigation-menu-item .item="${item}"></davinci-navigation-menu-item>`;
    });
  }

  onSlotChanged() {
    this.allItems = this.getAllNavigationItems();
    this.setTypeAttributeOnItems(this.allItems);
    this.recalculateMoreMenu();
  }

  getAllNavigationItems() {
    const allItems = [];

    for (const item of this.children) {
      if (item.tagName === 'DAVINCI-CORE-NAVIGATION-ITEM') {
        allItems.push(item);
      } else {
        // tslint:disable-next-line:no-console
        console.warn('`DAVINCI-CORE-NAVIGATION` must only have children of type `DAVINCI-CORE-NAVIGATION-ITEM`, but found ' + item.tagName);
      }
    }

    return allItems;
  }

  setTypeAttributeOnItems(items) {
    items.forEach(item => item.type = this.type);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'basic';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "moreMenuItems", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
})), _class2)) || _class);
